<template>
    <div class="k-loading" :class="classNames">
        <slot>数据加载中…</slot>
    </div>
</template>

<script>
    export default {
        name: 'k-loading',
        props: {
            name: [String, Number],
            shape: [String, Number],
            skin: [String, Number]
        },
        computed: {
            classNames() {
                const A = []
                const {
                    name,
                    shape,
                    skin
                } = this
                if (name) {
                    A.push(`k-loading-${name}`)
                }
                if (shape) {
                    A.push(`k-loading--${shape}`)
                }
                if (skin) {
                    A.push(`k-loading--${skin}`)
                }
                return A
            }
        }
    }

</script>
